import { gql } from "@apollo/client";

export default gql`
  query GetReport($slug: String!) {
    reportBySlug(slug: $slug) {
      _id
      title
      slug
      description
      images
      details
      governments {
        _id
        slug
        name
        logo
        ownerless
        isInnovator
      }
      unpublishedAt
      archivedAt
      createdAt
      updatedAt
    }
  }
`;
